






















import Vue from 'vue';
import axios from 'axios';
import RecordSelect from './RecordSelect.vue';

export default Vue.extend({
    name: 'CreateFillerBetaPdf',
    components: { RecordSelect },
    props: [ 'template' ],
    data() {
        return {
            disableButton: false,
            contactId: '',
            companyId: '',
            showPDFLink: false,
            PDFLink: ''
        }
    },
    methods: {
        submit() {
            if(!this.contactId && !this.companyId) {
                alert('Select a contact or company first.');
                return;
            }
            this.disableButton = true;
            axios.post(`${this.$store.state.apiUrl}/filler`, {
                template: this.template,
                contactId: this.contactId || null,
                companyId: this.companyId || null
            })
                .then(resp => {
                    this.disableButton = false;
                    this.PDFLink = `${this.$store.state.apiUrl}/pdf/${resp.data}`;
                    this.showPDFLink = true;
                })
                .catch(e => {
                    console.log(e.response?.data ? e.response.data : e);
                    // The backend now sends { code, message } for every handled
                    // failure - show its message directly instead of guessing
                    // from a status code, so the real cause (an expired HubSpot
                    // connection, a bad field mapping, a HubSpot-side error, etc.)
                    // is visible instead of a generic dead end.
                    const message = e.response?.data?.message;
                    alert(message || 'There was an error.');
                    this.disableButton = false;
                })
        },
        close() {
            this.$emit('close');
        }
    }
})
